import { useMemo, Fragment } from 'react';
import { Divider, List, Stack } from 'components/ui';
import ListItem from 'components/space/index/list_item';
import LoaderContainer from 'components/layout/loader_container';

const ROLE_ORDER = ['owner', 'admin', 'inspector', 'viewer'];

const groupByRole = (spaces) => {
  const groups = ROLE_ORDER.reduce((acc, role) => ({ ...acc, [role]: [] }), {});
  spaces.forEach((space) => {
    if (groups[space.role]) {
      groups[space.role].push(space);
    } else {
      groups.viewer.push(space);
    }
  });
  return ROLE_ORDER.map((role) => ({ role, items: groups[role] })).filter(
    (group) => group.items.length > 0
  );
};

const Index = ({ spaces, loading, onSelect }) => {
  const grouped = useMemo(() => groupByRole(spaces.spaces), [spaces.spaces]);

  return (
    <Stack spacing={3}>
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {grouped.map(({ role, items }, index) => (
          <Fragment key={role}>
            {index > 0 && <Divider sx={{ my: 2 }} />}
            <List disablePadding>
              {items.map((space) => (
                <ListItem key={space.id} space={space} onSelect={onSelect} />
              ))}
            </List>
          </Fragment>
        ))}
      </LoaderContainer>
    </Stack>
  );
};

export default Index;
